import { Component, OnInit, OnDestroy, Renderer2, Inject, ViewChild } from '@angular/core';
import { ThemeSettingsService } from '../../settings/theme-settings.service';
import { DOCUMENT } from '@angular/common';
import { NavbarService } from 'src/app/_services/navbar.service';
import { MenuSettingsService } from '../../settings/menu-settings.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PerfectScrollbarConfigInterface, PerfectScrollbarComponent, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { N8nChatService } from 'src/app/_services/n8n-chat.service';
import { StatsService } from 'src/app/_services/dispo/stats.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import moment from 'moment';
//import OpenAI from "openai";


declare var require: any;
const colors = require('../../../../assets/data/customizer/customizerColor.json');
//const openai = new OpenAI();

@Component({
  selector: 'app-horizontal-customizer',
  templateUrl: './horizontal-customizer.component.html',
  styleUrls: ['./horizontal-customizer.component.css']
})
export class HorizontalCustomizerComponent implements OnInit, OnDestroy {
  private _unsubscribeAll: Subject<any>;
  public _themeCustomizerConfig: any;
  public _menuCustomizerConfig: any;
  private _themeSettingsConfig: any;
  public selectColorClass: string;
  public isCollapsedMenu = false;
  public isRightSideIcons = false;

  activeIdString = 'light';

  /** Aktives Panel im Seiten-Customizer (horizontal layout). */
  activePanel: 'ki' | 'phone' | 'appointment' | 'email' | 'orders' = 'ki';

  messages: { text: string; sender: 'user' | 'ai' }[] = [];
  userInput = '';
  isLoading = false;

  /** Sipgate-Anrufliste (gleiche Quelle wie Dashboard Logistik) */
  sipgateCalls: any[] = [];
  sipgateHistoryTotal = 0;
  loadingSipgateCalls = false;
  sipgateError: string | null = null;

  /** Terminanfragen (gleiche API wie /appointment-requests-manager) */
  appointmentRequestsList: any[] = [];
  appointmentRequestsFiltered: any[] = [];
  appointmentAutoTransferred: any[] = [];
  appointmentSearch = '';
  loadingAppointmentRequests = false;
  appointmentError: string | null = null;

  /** E-Mails aus DB (gleiche API wie Kommunikation /mail-Liste) */
  mailsList: any[] = [];
  mailsFiltered: any[] = [];
  mailSearch = '';
  loadingMails = false;
  mailError: string | null = null;

  public config: PerfectScrollbarConfigInterface = { wheelPropagation: false };

  @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent;
  @ViewChild(PerfectScrollbarDirective, { static: true }) directiveRef?: PerfectScrollbarDirective;


  constructor(private _renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    private navbarService: NavbarService,
    private n8nChatService: N8nChatService,
    private _themeSettingsService: ThemeSettingsService,
    private _menuSettingsService: MenuSettingsService,
    private statsService: StatsService,
    private router: Router,
    private http: HttpClient
  ) {
    this._unsubscribeAll = new Subject();
  }
  ngOnInit() {

    this._themeSettingsService.config
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((config) => {
        this._themeCustomizerConfig = config;
      });
    this._themeSettingsService.config
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((config) => {
        this._themeSettingsConfig = config;
      });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  /** Tab wechseln; Telefonliste lädt Sipgate-Historie. */
  selectPanel(panel: 'ki' | 'phone' | 'appointment' | 'email' | 'orders'): void {
    this.activePanel = panel;
    if (panel === 'phone') {
      this.loadSipgateCalls();
    }
    if (panel === 'appointment') {
      this.loadAppointmentRequests();
    }
    if (panel === 'email') {
      this.loadMails();
    }
  }

  loadSipgateCalls(): void {
    this.loadingSipgateCalls = true;
    this.sipgateError = null;
    this.statsService.getStats({ history_limit: 50, history_offset: 0 }).subscribe({
      next: (data: any) => {
        const sg = data?.sipgateStats;
        if (sg?.error) {
          this.sipgateError = typeof sg.error === 'string' ? sg.error : 'Sipgate nicht verfügbar.';
          this.sipgateCalls = [];
          this.sipgateHistoryTotal = 0;
        } else {
          const hist = sg?.history;
          this.sipgateCalls = hist?.items || [];
          this.sipgateHistoryTotal = hist?.totalCount ?? this.sipgateCalls.length;
        }
        this.loadingSipgateCalls = false;
      },
      error: () => {
        this.sipgateError = 'Anrufliste konnte nicht geladen werden.';
        this.sipgateCalls = [];
        this.loadingSipgateCalls = false;
      }
    });
  }

  /** „vor …“ wie im Logistik-Dashboard */
  getTimeDifference(created: string): string {
    if (!created) return '–';
    const jetzt = moment();
    const erstelltAm = moment(created);
    const dauer = moment.duration(jetzt.diff(erstelltAm));
    let deText = dauer.humanize();
    const translations: Record<string, string> = {
      'a few seconds': 'Gerade eben',
      'a minute': '1 Min',
      minutes: 'Min',
      'an hour': '1 Std',
      hours: 'Std',
      'a day': '1 Tag',
      days: 'Tage',
      'a month': '1 Monat',
      months: 'Monate',
      'a year': '1 Jahr',
      years: 'Jahre',
      ago: ''
    };
    for (const [eng, de] of Object.entries(translations)) {
      deText = deText.replace(eng, de);
    }
    return deText.trim();
  }

  /** Für Tabellen: nur wenn CRM Vor-/Nachname fehlen, Alias in der ersten Namenszeile. */
  hasStructuredName(call: any): boolean {
    return !!(call?.first_name || call?.last_name);
  }

  getNameFirstLine(call: any): string {
    if (this.hasStructuredName(call)) {
      return (call?.first_name || '').trim() || '–';
    }
    return (call?.sourceAlias || '').trim() || '–';
  }

  getNameSecondLine(call: any): string {
    return (call?.last_name || '').trim() || '–';
  }

  navigateToOrder(call: any): void {
    if (call?.order_id) {
      this.router.navigate(['/order', call.order_id, 'order-base']);
    }
  }

  loadAppointmentRequests(): void {
    this.loadingAppointmentRequests = true;
    this.appointmentError = null;
    this.http.get<any[]>(environment.prismaApiUrl + '/api/dispo/appointment-requests').subscribe({
      next: (data) => {
        this.appointmentRequestsList = Array.isArray(data) ? data : [];
        this.applyAppointmentFilter();
        this.loadingAppointmentRequests = false;
      },
      error: () => {
        this.appointmentError = 'Terminanfragen konnten nicht geladen werden.';
        this.appointmentRequestsList = [];
        this.appointmentRequestsFiltered = [];
        this.appointmentAutoTransferred = [];
        this.loadingAppointmentRequests = false;
      }
    });
  }

  applyAppointmentFilter(): void {
    const q = (this.appointmentSearch || '').trim().toLowerCase();
    const base = this.appointmentRequestsList.slice();
    this.appointmentAutoTransferred = base
      .filter((item) => String(item?.set_touren_status || '').toLowerCase() === 'success')
      .sort((a, b) => {
        const da = new Date(a.set_touren_at || a.confirmed_at || 0).getTime();
        const db = new Date(b.set_touren_at || b.confirmed_at || 0).getTime();
        return db - da;
      })
      .slice(0, 30);

    if (!q) {
      this.appointmentRequestsFiltered = base;
      return;
    }
    this.appointmentRequestsFiltered = base.filter(item => {
      const on = (item.order_number ?? '').toString().toLowerCase();
      const name = (item.name || '').toLowerCase();
      const email = (item.email || '').toLowerCase();
      const reason = (item.decline_reason ?? '').toString().toLowerCase();
      return on.includes(q) || name.includes(q) || email.includes(q) || reason.includes(q);
    });
  }

  /** Tooltip: bei Absage optional die Kunden-Begründung. */
  getAppointmentRowTitle(item: any): string {
    if (this.getAppointmentStatus(item) !== 'declined') {
      return '';
    }
    const r = (item?.decline_reason ?? '').toString().trim();
    return r ? 'Begründung (Kunde): ' + r : '';
  }

  getAppointmentStatus(item: any): 'confirmed' | 'declined' | 'pending' {
    if (item.confirmed_at) return 'confirmed';
    if (item.declined_at) return 'declined';
    return 'pending';
  }

  getAppointmentStatusLabel(item: any): string {
    const s = this.getAppointmentStatus(item);
    if (s === 'confirmed') return 'Bestätigt';
    if (s === 'declined') return 'nicht bestätigt';
    return 'Wartend';
  }

  formatAppointmentDate(value: string | null | undefined): string {
    if (!value) return '–';
    const m = moment(value);
    return m.isValid() ? m.format('DD.MM.YYYY HH:mm') : '–';
  }

  navigateToAppointmentOrder(item: any): void {
    if (item?.order_id) {
      this.router.navigate(['/order', item.order_id, 'order-base']);
    }
  }

  loadMails(): void {
    this.loadingMails = true;
    this.mailError = null;
    this.http.get<any[]>(environment.prismaApiUrl + '/api/dispo/mails').subscribe({
      next: (data) => {
        const arr = Array.isArray(data) ? data : [];
        this.mailsList = arr.sort((a, b) => {
          const da = new Date(a.created_at || a.date || 0).getTime();
          const db = new Date(b.created_at || b.date || 0).getTime();
          return db - da;
        });
        this.applyMailFilter();
        this.loadingMails = false;
      },
      error: () => {
        this.mailError = 'E-Mails konnten nicht geladen werden.';
        this.mailsList = [];
        this.mailsFiltered = [];
        this.loadingMails = false;
      }
    });
  }

  applyMailFilter(): void {
    const q = (this.mailSearch || '').trim().toLowerCase();
    if (!q) {
      this.mailsFiltered = this.mailsList.slice();
      return;
    }
    this.mailsFiltered = this.mailsList.filter((m) => {
      const on = (m.order_number ?? '').toString().toLowerCase();
      const fromStr = (m.from || '').toString();
      const name = this.getMailDisplayName(fromStr).toLowerCase();
      const email = this.getMailFromEmail(fromStr).toLowerCase();
      return on.includes(q) || name.includes(q) || email.includes(q);
    });
  }

  /** Anzeigename aus „Von“ (z. B. „Max M. <a@b.de>“ → „Max M.“) */
  getMailDisplayName(from: string | null | undefined): string {
    if (from == null || typeof from !== 'string') return '';
    const trimmed = from.trim();
    const m = trimmed.match(/^(.+?)\s*<[^>]+>\s*$/);
    if (m) return m[1].trim().replace(/^["']|["']$/g, '').trim();
    return '';
  }

  /** E-Mail-Adresse aus „Von“ */
  getMailFromEmail(from: string | null | undefined): string {
    if (from == null || typeof from !== 'string') return '';
    const trimmed = from.trim();
    const angle = trimmed.match(/<([^>]+)>/);
    if (angle) return angle[1].trim();
    const loose = trimmed.match(/[\w.+-]+@[\w.-]+\.\w+/);
    return loose ? loose[0] : '';
  }

  getMailEmailCell(mail: any): string {
    const e = this.getMailFromEmail(mail?.from);
    if (e) return e;
    const r = (mail?.recipients || '').toString().trim();
    if (r) return r;
    return '–';
  }

  getMailNameCell(mail: any): string {
    const n = this.getMailDisplayName(mail?.from);
    if (n) return n;
    const f = (mail?.from || '').toString().trim();
    if (f && !this.getMailFromEmail(f)) return f;
    return '–';
  }

  isMailIncoming(mail: any): boolean {
    return (mail?.direction || '').toString().toLowerCase() === 'incoming';
  }

  navigateToMailOrder(mail: any): void {
    if (mail?.order_id) {
      this.router.navigate(['/order', mail.order_id, 'order-base']);
    }
  }

  toggleCustomizer(event) {
    const element = document.getElementById('customizer');
    if (element && element.classList.contains('open')) {
      this._renderer.removeClass(element, 'open');
    } else {
      this._renderer.addClass(element, 'open');
    }
  }

  sendMessage(): void {
    const text = this.userInput?.trim();
    if (!text || this.isLoading) return;

    this.messages.push({ text, sender: 'user' });
    this.userInput = '';
    this.isLoading = true;

    this.n8nChatService.sendMessage(text).subscribe({
      next: (response) => {
        this.messages.push({ text: response, sender: 'ai' });
        this.isLoading = false;
      },
      error: () => {
        this.messages.push({ text: 'Ein Fehler ist aufgetreten.', sender: 'ai' });
        this.isLoading = false;
      }
    });
  }

  clearChat(): void {
    this.messages = [];
    this.n8nChatService.resetSession();
  }


 
}
